import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useUi } from "@/i18n/ui";
import { forgotPassword, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const { lang } = useApp();
  const t = useUi(lang);
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rbl-auth-wrap" data-testid="forgot-page">
      <div className="rbl-auth-card">
        <img src="/logo_rbl.png" alt="RBL Training" style={{ height: 48 }} />
        <h1>{t("forgotTitle")}</h1>
        <div className="sub">{t("forgotDesc")}</div>
        {sent ? (
          <div className="rbl-ok" data-testid="forgot-success">{t("resetSent")}</div>
        ) : (
          <>
            {error && <div className="rbl-error">{error}</div>}
            <form onSubmit={submit}>
              <div className="rbl-field">
                <label className="rbl-label">{t("email")}</label>
                <input className="rbl-input" type="email" data-testid="forgot-email"
                  value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <button className="rbl-btn block" type="submit" disabled={busy} data-testid="forgot-submit">
                {busy ? "…" : t("sendResetLink")}
              </button>
            </form>
          </>
        )}
        <div className="rbl-auth-foot">
          <Link to="/login" className="rbl-link">{t("login")}</Link>
          <Link to="/" className="rbl-link">{t("backToHub")}</Link>
        </div>
      </div>
    </div>
  );
}
